import { spenttimeDebug as debug } from '../modules/debug';
import { SPENTTIME_STATES, EVENT } from '../constants';
import { addEventForCypress } from '../utils/addCustomEvent';
/**
 * Сounting the spent time
 */
var SpenttimeHandler = /** @class */ (function () {
    /**
     * Constructor
     */
    function SpenttimeHandler(delay, id /*id only for logging and tests*/) {
        if (delay === void 0) { delay = 0; }
        if (id === void 0) { id = 'container'; }
        /**
         * Start time of the spenttime account (timestamp)
         */
        this.startTime = null;
        /**
         * Timestamp of spenttime (ms)
         */
        this.spenttime = 0;
        /**
         * Spenttime change indicator
         */
        this._wasChange = false;
        this.delay = delay;
        this.init(id);
    }
    Object.defineProperty(SpenttimeHandler.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (value) {
            this._state = value;
        },
        enumerable: false,
        configurable: true
    });
    // used in the cypress
    SpenttimeHandler.prototype.getState = function () {
        return this._state;
    };
    Object.defineProperty(SpenttimeHandler.prototype, "wasChange", {
        get: function () {
            return this._wasChange;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the final amount of spenttime
     * @returns Spenttime (ms)
     */
    SpenttimeHandler.prototype.getSpenttime = function () {
        if (this.startTime) {
            var spenttimeWithDelay = this.spenttime + new Date().getTime() - this.startTime - this.delay;
            var finalSpenttime = spenttimeWithDelay <= 0 ? 0 : spenttimeWithDelay;
            return finalSpenttime <= 0 ? 0 : finalSpenttime;
        }
        return this.spenttime;
    };
    SpenttimeHandler.prototype.getSpenttimeInSeconds = function () {
        var finalSpenttime = this.getSpenttime();
        // milliseconds => seconds with two decimal places
        return finalSpenttime ? parseInt((finalSpenttime / 10).toString(), 10) / 100 : 0;
    };
    /**
     * Initialization
     */
    SpenttimeHandler.prototype.init = function (id /*id only for logging and tests*/) {
        if (id === void 0) { id = 'container'; }
        debug("INITED \"".concat(id, "\""));
        this.startTime = null;
        this.spenttime = 0;
        this._wasChange = false;
        this.state = SPENTTIME_STATES.inited;
        addEventForCypress(EVENT.stateInited, id);
    };
    /**
     * Reset
     * used after sending data to the server
     */
    SpenttimeHandler.prototype.reset = function (id /*id only for logging and tests*/) {
        if (id === void 0) { id = 'container'; }
        if (this.state === SPENTTIME_STATES.done) {
            return;
        }
        if (this.state === SPENTTIME_STATES.running) {
            this.init(id);
            this.run(id);
        }
        else {
            this.init(id);
        }
    };
    /**
     * Starting the measurement of spenttime
     */
    SpenttimeHandler.prototype.run = function (id /*id only for logging and tests*/) {
        if (id === void 0) { id = 'container'; }
        if (this.state === SPENTTIME_STATES.running || this.state === SPENTTIME_STATES.done) {
            return;
        }
        debug("RUN    \"".concat(id, "\""));
        this.state = SPENTTIME_STATES.running;
        this._wasChange = true;
        this.startTime = new Date().getTime();
        addEventForCypress(EVENT.stateRun, id);
    };
    /**
     * Pausing the measurement of spenttime
     */
    SpenttimeHandler.prototype.pause = function (id /*id only for logging and tests*/) {
        if (id === void 0) { id = 'container'; }
        if (this.state !== SPENTTIME_STATES.running) {
            return;
        }
        debug("PAUSE  \"".concat(id, "\""));
        this.state = SPENTTIME_STATES.paused;
        this.spenttime = this.getSpenttime();
        this.startTime = null;
        addEventForCypress(EVENT.statePaused, id);
    };
    /**
     * Completing the measurement of spenttime
     * Sending the result (time of spenttime) to the server (hit)
     */
    SpenttimeHandler.prototype.end = function () {
        if (this.state === SPENTTIME_STATES.done) {
            return;
        }
        debug('DONE');
        this.state = SPENTTIME_STATES.done;
        addEventForCypress(EVENT.stateDone);
    };
    return SpenttimeHandler;
}());
export default SpenttimeHandler;
